<script setup>
import { useSlots } from "vue";
import BoxOpen from "@/components/icons/BoxOpen.vue";

defineProps({
  title: { type: String, default: "" },
  description: { type: String, default: "" },
  bordered: { type: Boolean, default: false },
});

const slots = useSlots();
</script>

<template>
  <div class="empty-state" :class="{ 'empty-state_bordered': bordered }">
    <span class="empty-state__icon">
      <slot name="icon">
        <BoxOpen />
      </slot>
    </span>

    <div class="empty-state__text">
      <p class="empty-state__title">
        <slot name="title">{{ title }}</slot>
      </p>

      <p
        v-if="description || slots.description"
        class="empty-state__description"
      >
        <slot name="description">{{ description }}</slot>
      </p>
    </div>

    <div v-if="slots.default" class="empty-state__actions">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 16px;
  text-align: center;

  &_bordered {
    border: 1px dashed var(--gray-300);
    border-radius: 12px;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-400);

    :deep(.material-icons) {
      font-size: 20px;
    }

    :deep(svg) {
      width: 20px;
      height: 20px;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  &__title {
    margin: 0;
    font-family: var(--font-manrope);
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: var(--gray-950);
  }

  &__description {
    max-width: 420px;
    margin: 0;
    font-family: var(--font-manrope);
    font-size: 14px;
    line-height: 22px;
    color: var(--gray-600);
  }

  &__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
}
</style>
